<template>

    <section id="user-actions" v-if="auth">

        <button id="auth" :title="`Vis handlinger for ${ user_name }`" @click="toggleMenu()">{{ user_initial }}</button>
        
        <ul class="menu" v-if="display_menu">
            <li>
                <button @click="navTo('/profile')">Profil</button>
            </li>
            <li>
                <button @click="logout()">Log ud</button>
            </li>
        </ul>
        
    </section>

</template>

<script>

    export default {
        data () {
            return {
                display_menu: false
            }
        },
        computed: {
            auth: function() {
                return this.$store.getters.isAuthenticated
            },
            user: function() {
                return this.$store.getters.getUser
            },
            user_name: function() {
                if (!this.user) {
                    return ''
                } else if (this.user.first_name) {
                    return `${ this.user.first_name } ${ this.user.last_name }`
                } else {
                    return this.user.username
                }
            },
            user_initial: function() {
                if (!this.user_name) {
                    return ''
                }
                return this.user_name.substr(0,1)
            }
        },
        methods: {
            toggleMenu: function() {
                this.display_menu = !this.display_menu
            },
            navTo: function(destination) {
                this.toggleMenu()
                this.$router.push(destination)
            },
            logout: function() {
                this.toggleMenu()
                if (confirm('Vil du logge ud?')) {
                    this.$store.dispatch('logout')
                }
            }
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #user-actions {

        #auth {
            height: 2rem;
            width: 2rem;
            border-radius: 50%;
            background-color: $grey6;
            color: $grey0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            text-transform: uppercase;
            font-size: 1.25rem;
            line-height: 1;

            &:hover,
            &:active {
                background-color: $grey10;
            }
        }
        .menu {
            display: block;
            list-style: none;
            margin: 0;
            padding: 0;
            position: absolute;
            top: 3rem;
            right: .5rem;
            min-width: 7.5rem;
            background-color: $grey0;
            z-index: 2;
            box-shadow: 0 .25rem .25rem hsla(0,0%,0%,.2);

            button {
                background-color: transparent;
                text-align: left;
                font-size: .9rem;
                text-decoration: none;
                padding: .5rem 1rem;
                display: block;
                width: 100%;
                border-bottom: solid 1px $grey1;
            }
            &::before {
                content: '';
                display: block;
                height: 1rem;
                width: 1rem;
                position: absolute;
                top: -.5rem;
                right: 1rem;
                transform: rotate(45deg);
                background-color: $grey0;
            }
        }
        
    }

</style>